import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { isKeycloakAuthenticated, isKeycloakReady } from "./selectors";
import { withRouterCompat } from "./utils";
import HeaderMenuItems from "./components/headers/HeaderMenuItems";
import Applications from "./components/applications-list/Applications";
import EditRoleWrapper from "./components/manage-application/manage-role/EditRoleWrapper";
import styles from "./assets/App.css";
import { Routes, Route } from "react-router";
import {
  LoginRequired,
  CernFooter,
  FullPageLoader,
} from "@authzsvc/common-react-components";
import TokenExchangePanelWrapper from "./components/token-exchange/TokenExchangePanelWrapper";
import RequestsWrapper from "./components/requests/RequestsWrapper";
import RequestDetailsWrapper from "./components/requests/RequestDetailsWrapper";
import Application from "./components/manage-application/Application";
import { Layout } from "antd";
import SiteHeader from "./components/applications-list/SiteHeader";

export class App extends Component {
  static propTypes = {
    ready: PropTypes.bool.isRequired,
    authenticated: PropTypes.bool.isRequired,
    sidebarVisible: PropTypes.bool.isRequired,
  };

  render() {
    const { ready, authenticated } = this.props;

    if (!ready) {
      return <FullPageLoader />;
    }

    return (
      <div>
        <div
          style={{
            minHeight: "100vh",
            display: "flex",
            flexDirection: "column",
            backgroundColor: "#f0f2f5",
          }}
        >
          <HeaderMenuItems />
          <div
            className={styles.segment}
            style={{
              flexGrow: 1,
              padding: "64px",
            }}
          >
            {authenticated ? (
              <>
                <Layout.Content
                  className={styles.container}
                  style={{
                    maxWidth: 1500,
                    margin: "0 auto",
                    width: "100%",
                    backgroundColor: "#fff",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.15)",
                    borderRadius: 8,
                  }}
                >
                  <SiteHeader
                    title="CERN Applications"
                    subTitle="Manage your CERN Applications, their connection to Single Sign-On and their access control"
                  />

                  <div className={styles.blueSegment}>
                    <Routes>
                      <Route
                        path="/"
                        element={
                          <Applications breadcrumbs={[["/", "Applications"]]} />
                        }
                      />
                      <Route
                        path="/manage/:appid/role/:roleid"
                        element={
                          <EditRoleWrapper
                            breadcrumbs={[
                              ["/", "Applications"],
                              ["DYNAMIC", "My Application"],
                              ["DYNAMIC", "My Role"],
                            ]}
                          />
                        }
                      />
                      <Route
                        path="/manage/:appid/:tab?"
                        element={
                          <Application
                            breadcrumbs={[
                              ["/", "Applications"],
                              ["DYNAMIC", "My Application"],
                            ]}
                          />
                        }
                      />
                      <Route
                        path="/token-exchange/:appid/:regid"
                        element={
                          <TokenExchangePanelWrapper
                            breadcrumbs={[
                              ["/", "Applications"],
                              ["DYNAMIC", "My Application"],
                              ["DYNAMIC", "Token exchange permissions"],
                            ]}
                          />
                        }
                      />
                      <Route
                        path="/requests"
                        element={
                          <RequestsWrapper
                            breadcrumbs={[["/requests", "Requests"]]}
                          />
                        }
                      />
                      <Route
                        path="/requests/:id"
                        element={
                          <RequestDetailsWrapper
                            breadcrumbs={[
                              ["/requests", "Requests"],
                              ["DYNAMIC", "Request Details"],
                            ]}
                          />
                        }
                      />
                    </Routes>
                  </div>
                </Layout.Content>
              </>
            ) : (
              <LoginRequired />
            )}
          </div>
          <div style={{ flexGrow: 0 }}>
            <CernFooter />
          </div>
        </div>
      </div>
    );
  }
}

export default connect((state) => ({
  ready: isKeycloakReady(state),
  authenticated: isKeycloakAuthenticated(state),
  sidebarVisible: state.sidebar.visible,
}))(withRouterCompat(App));
